import app from 'flarum/forum/app';
app.initializers.add('pianotell-pianotell', () => {
  app.beforeMount(() => {
    // Keeping the forum setting on "auto" is what exposes Flarum's color
    // scheme selector to members. Guests have no preference record, however,
    // so core would otherwise resolve "auto" from their operating system.
    if (!app.session.user && app.forum.attribute('colorScheme') === 'auto') {
      app.forum.pushAttributes({
        colorScheme: 'light'
      });
    }
  });
});